import * as React from "react";
import { SVGProps } from "react";
const SvgImportantIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={95} height={95} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M52.385 53.68 53.299 29H42.127l.914 24.68h9.344zm-4.672 12.974c3.656 0 5.713-1.777 5.713-4.95 0-3.2-2.057-4.977-5.713-4.977S42 58.504 42 61.703c0 3.174 2.057 4.951 5.713 4.951z"
      fill="#FFF"
    />
  </svg>
);
export default SvgImportantIcon;
